export default "__VITE_ASSET__DGkqWijX__"